import { z } from 'zod';

import { Option } from '../../types/Option';

export const AC_EARTHED_CONDUCTORS = ['L1', 'L2', 'L3', 'N'] as const;
export const DC_EARTHED_CONDUCTORS = ['L+', 'M', 'L-'] as const;

export type AcEarthedConductorValue = (typeof AC_EARTHED_CONDUCTORS)[number];
export type DcEarthedConductorValue = (typeof DC_EARTHED_CONDUCTORS)[number];

const AcOptions: Option<AcEarthedConductorValue>[] = AC_EARTHED_CONDUCTORS.map((value) => ({ value, label: value }));
const DcOptions: Option<DcEarthedConductorValue>[] = DC_EARTHED_CONDUCTORS.map((value) => ({ value, label: value }));

const AcEarthedConductor = {
    validator: z.enum(AC_EARTHED_CONDUCTORS).nullable().default(null),
    options: AcOptions,
};

const DcEarthedConductor = {
    validator: z.enum(DC_EARTHED_CONDUCTORS).nullable().default(null),
    options: DcOptions,
};

export { AcEarthedConductor, DcEarthedConductor };
